(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tabs-acc"] && !Shopify.designMode) return;
  try {
    
   document.addEventListener('DOMContentLoaded', function () {
      var tabs = document.querySelectorAll('.custom-tab');
      var tabContents = document.querySelectorAll('.custom__tab-content');

      // Make the first tab and content active by default
      tabs[0].classList.add('active');
      tabContents[0].classList.add('active');

      tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
              contentId = this.dataset.contentId;
              content = document.getElementById(contentId);

              tabContents.forEach(function (content) {
                  content.classList.remove('active');
              });

              tabs.forEach(function (tab) {
                  tab.classList.remove('active');
              });

              this.classList.add('active');
              content.classList.add('active');
          });
      });
  });

  } catch(e) { console.error(e); }
})();
})();
